import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { LocalizationProvider } from './context/localizationContext';
import reportWebVitals from './reportWebVitals';
import ImportValidator from './helpers/ImportValidator';

const container = document.getElementsByTagName('PingNationWebfitWidget')[0];

if (!container) {
  console.error('DOM Element does not exist');
} else {
  const organization = ImportValidator.validateOrganization(
    container.getAttribute('organization'),
  );

  const root = ReactDOM.createRoot(container);
  root.render(
    <LocalizationProvider>
      <App organization={organization} />
    </LocalizationProvider>,
  );
  // ReactDOM.render(
  //   <LocalizationProvider>
  //     <App organization={organization} />
  //   </LocalizationProvider>,
  //   container,
  // );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
